export var CHART_COLORS = ['#2b87c8', '#ff7043', '#66bb6a', '#ab47bc', '#ffa726', '#26a69a', '#ef5350'];

export function hasSeries(rows) {
  return (rows || []).some(function (row) {
    return row && typeof row === 'object' && row.series !== undefined && row.series !== null && row.series !== '';
  });
}

export function normalizeName(rows) {
  return (rows || []).map(function (row, index) {
    if (!row || typeof row !== 'object') {
      return {
        name: String(index + 1),
        value: Number(row) || 0
      };
    }

    var name = row.name !== undefined ? row.name : row.xAxis !== undefined ? row.xAxis : String(index + 1);
    var value = row.value !== undefined ? row.value : row.series1 !== undefined ? row.series1 : 0;

    return {
      ...row,
      name: String(name),
      value: Number(value) || 0
    };
  });
}

export function getSeriesKeys(rows) {
  if (!hasSeries(rows)) {
    return ['value'];
  }

  var unique = new Set();
  (rows || []).forEach(function (row) {
    if (row && row.series !== undefined && row.series !== null && row.series !== '') {
      unique.add(String(row.series));
    }
  });

  return Array.from(unique);
}

export function toWideSeriesRows(rows) {
  var normalized = normalizeName(rows);

  if (!hasSeries(normalized)) {
    return {
      data: normalized,
      seriesKeys: ['value']
    };
  }

  var pointsByName = {};
  normalized.forEach(function (row) {
    if (!pointsByName[row.name]) {
      pointsByName[row.name] = { name: row.name };
    }

    pointsByName[row.name][String(row.series)] = row.value;
  });

  return {
    data: Object.keys(pointsByName).map(function (key) {
      return pointsByName[key];
    }),
    seriesKeys: getSeriesKeys(normalized)
  };
}

export function getVisibleSeries(seriesKeys, isolatedSeries) {
  if (!isolatedSeries) {
    return seriesKeys;
  }

  return seriesKeys.filter(function (seriesKey) {
    return seriesKey === isolatedSeries;
  });
}

export function aggregatePieData(rows, isolatedSeries) {
  var normalized = normalizeName(rows);
  var grouped = {};

  normalized.forEach(function (row) {
    if (isolatedSeries && String(row.series) !== String(isolatedSeries)) {
      return;
    }

    if (!grouped[row.name]) {
      grouped[row.name] = 0;
    }

    grouped[row.name] += Number(row.value) || 0;
  });

  return Object.keys(grouped).map(function (name) {
    return {
      name,
      value: grouped[name]
    };
  });
}
